<template>
  <component
    :is="wrapper"
    :href="url"
    class="whatsapp-button-base"
    :class="customClass"
    title="Fale Conosco"
    rel="nofollow"
    target="_blank"
    @click="onContact"
  >
    <label class="cursor-pointer">{{ label }}</label>
    <img
      v-if="showIcon"
      class="invert"
      :src="iconSrc"
      :width="iconSize"
      :height="iconSize"
      alt="whatsapp"
    />
  </component>
</template>

<script>
import { trackTiktokEvent } from "@/composables/useTiktokEvent";
export default {
  name: "LinkButton",
  props: {
    url: { type: String, required: true },
    label: { type: String, default: "Fale Conosco" },
    iconSrc: { type: String, default: "/img/icons/whatsapp.svg" },
    iconSize: { type: [Number, String], default: 24 },
    showIcon: { type: Boolean, default: true },
    wrapper: { type: String, default: "a" },
    customClass: { type: String, default: "" },
  },
  methods: {
    onContact() {
      trackTiktokEvent('Contact')
    },
  },
};
</script>

<style scoped>
.whatsapp-button-base {
  @apply rounded-[8px] text-[--white] w-full py-[12.5px] text-center flex flex-row items-center gap-[10px] bg-[#24d366] md:w-[373px] justify-center font-semibold text-xl cursor-pointer;
}
</style>
